import {intersection, uniq} from 'lodash';

import {
  ClientRequiredTaggingParameter,
  RequiredTaggingParameterModel,
} from '../../../../../../models/api/requiredTaggingModel';
import {SafetyNetModel} from '../../../../../../models/api/safetyNetModel';
import {decorateWithClientId} from '../../../../../editors/commons/clientIdModel';
import {RequiredTaggingEditorErrorsEnum} from '../requiredTaggingEditorErrors';

type RequiredTaggingParamsState = ReadonlyArray<ClientRequiredTaggingParameter>;

/*
 * Types.
 */

export interface RequiredTaggingParamsEditorState {
  requiredTaggingParamsState: RequiredTaggingParamsState;
}

/*
 * State.
 */

export function requiredTaggingParamsCreateInitialState(
  initialParameters?: ReadonlyArray<RequiredTaggingParameterModel>,
): RequiredTaggingParamsEditorState {
  const requiredTaggingParamsState = initialParameters
    ? initialParameters.map(decorateWithClientId)
    : [createEmptyRequiredTaggingParameter()];

  return {requiredTaggingParamsState};
}

export function createEmptyRequiredTaggingParameter(): ClientRequiredTaggingParameter {
  return decorateWithClientId({tagListName: '', tagIds: [], isOneTagRequired: false});
}

export function getRequiredTaggingParamsErrors(
  state: RequiredTaggingParamsEditorState,
  safetyNets: ReadonlyArray<SafetyNetModel>,
  hasHighlightErrorsFlag: boolean,
): ReadonlyArray<RequiredTaggingEditorErrorsEnum> {
  const errors: RequiredTaggingEditorErrorsEnum[] = [];

  if (state.requiredTaggingParamsState.length === 0) {
    errors.push(RequiredTaggingEditorErrorsEnum.NO_TAG_LIST);
  }

  if (hasHighlightErrorsFlag) {
    return errors;
  }

  if (
    !state.requiredTaggingParamsState.every(
      (requiredTaggingParam) =>
        requiredTaggingParam.tagIds.length !== 0 && requiredTaggingParam.tagListName !== '',
    )
  ) {
    errors.push(RequiredTaggingEditorErrorsEnum.INVALID_TAG_LIST);
  }

  const existingSafetyNetNames = safetyNets.map((net) => net.name);
  const constructingSafetyNetNames = state.requiredTaggingParamsState.map((it) => it.tagListName.trim());
  if (
    intersection(existingSafetyNetNames, constructingSafetyNetNames).length > 0 ||
    uniq(constructingSafetyNetNames).length !== constructingSafetyNetNames.length
  ) {
    errors.push(RequiredTaggingEditorErrorsEnum.TAG_LIST_NAME_CONFLICT);
  }

  return errors;
}
